import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiChevronDown } from 'react-icons/fi';

function HeroSlider() {

  const navigate = useNavigate();

  const images = [
    "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1920&q=80",
    "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?auto=format&fit=crop&w=1920&q=80",
    "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&w=1920&q=80",
    "https://images.unsplash.com/photo-1601918774946-25832a4be0d6?auto=format&fit=crop&w=1920&q=80"
  ];

  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative h-screen overflow-hidden">

      {/* Slides */}
      {images.map((img, index) => (
        <div
          key={index}
          className={`absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ${
            index === current ? "opacity-100" : "opacity-0"
          }`}
          style={{ backgroundImage: `url(${img})` }}
        />
      ))}

      {/* Bottom gradient fade for luxury look */}
      <div className="absolute bottom-0 left-0 right-0 h-48 bg-gradient-to-t from-black/60 to-transparent"></div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center text-white px-6">

        <div className="max-w-4xl animate-fadeIn">
          <div className="inline-block bg-black/30 backdrop-blur-sm px-5 py-5 rounded-2xl">
            <h1 className="text-4xl md:text-5xl font-luxury font-semibold leading-tight mb-3 tracking-wide brand-green-text">
              Hotels & Restaurants Near You
            </h1>

            <p className="text-base md:text-lg text-gray-100 mb-6">
              Discover the best nearby hotels, resorts, and restaurants with real photos, and easy location search
            </p>

            <div className="flex flex-col md:flex-row gap-3 justify-center">
              <button
                onClick={() => navigate("/hotels")}
                className="brand-orange-bg text-white px-8 py-3 rounded-full shadow-luxury hover:scale-105 transition duration-300 text-sm"
              >
                Discover Hotels
              </button>
              <button
                onClick={() => navigate("/restaurants")}
                className="brand-orange-bg text-white px-8 py-3 rounded-full shadow-luxury hover:scale-105 transition duration-300 text-sm"
              >
                Discover Restaurants
              </button>
            </div>
          </div>
        </div>

      </div>

      {/* Navigation Dots */}
      <div className="absolute bottom-16 left-1/2 -translate-x-1/2 flex space-x-3 z-20">
        {images.map((_, index) => (
          <div
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-3 h-3 rounded-full cursor-pointer transition ${
              index === current
                ? "brand-orange-bg scale-110"
                : "bg-white/60"
            }`}
          />
        ))}
      </div>

      {/* Down arrow - scroll to Trending Hotels */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-20">
        <button
          onClick={() => {
            const el = document.getElementById('trending-hotels');
            if (el) el.scrollIntoView({ behavior: 'smooth' });
          }}
          aria-label="Scroll to Trending"
          className="text-white"
        >
          <FiChevronDown size={28} className="animate-bounce" />
        </button>
      </div>

    </section>
  );
}

export default HeroSlider;
